import { useTranslation } from '@presentation/utils';
import { round } from 'lodash/fp';
import type { FC } from 'react';
import { LoadingContainer } from '..';
import { IconScaleStars } from '../IconScaleStars';
import { Pagination, PaginationWrapper } from '../Pagination';
import type { ReviewItemProps } from './ReviewItem';
import { ReviewItem } from './ReviewItem';
import * as Styled from './styled';
import type { BreederReviewListProps } from './types';

export * from './types';

export const BreederReviewList: FC<BreederReviewListProps> = (props) => {
  const {
    pagination,
    amount,
    average,
    categoryAverage,
    items,
    loading = false,
    reviewsRef,
    ...rest
  } = props;
  const { translate } = useTranslation();

  if (loading) return <LoadingContainer />;

  return (
    <>
      <Styled.Wrapper {...rest} className="review-list-wrapper">
        <Styled.Header>
          {!!average && !!amount ? (
            <div>
              <Styled.AverageWrapper>
                <span>{round(average)}</span>
                <IconScaleStars amount={average} />
              </Styled.AverageWrapper>
              <Styled.AmountText>
                {translate('common.sections.reviews.count').replaceAll('$nb', amount.toString())}
              </Styled.AmountText>
            </div>
          ) : null}

          {categoryAverage ? (
            <Styled.DetailList
              items={Object.keys(categoryAverage ?? {})
                .filter((key) => categoryAverage[key as keyof typeof categoryAverage] != null)
                .map((category) => ({
                  label: translate(`glossary.${category}`),
                  value: (
                    <IconScaleStars
                      amount={categoryAverage[category as keyof typeof categoryAverage] ?? 0}
                    />
                  ),
                }))}
            />
          ) : null}
        </Styled.Header>
        <Styled.ItemContainer ref={reviewsRef}>
          {items.map((item, index) => (
            <ReviewItem {...({ ...item, loading, ...rest } as ReviewItemProps)} key={index} />
          ))}
        </Styled.ItemContainer>
        {pagination && (
          <PaginationWrapper>
            <Pagination {...pagination} marginPagesDisplayed={1} pageRangeDisplayed={2} />
          </PaginationWrapper>
        )}
      </Styled.Wrapper>
    </>
  );
};
